<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <log-form-coach
                entityType="relations"
                :entityId="relationId"
                :override-endpoint="overrideEndpoint"
                :id="logId"
                :trajectoryId="trajectoryId"
                :milestoneProgressId="milestoneProgressId"
                :actionProgressId="actionProgressId"
            />
        </b-card>
    </div>
</template>

<script>
    import LogFormCoach from '~/components/forms/logs/form-coach'

    export default {
        name: 'edit',
        props: {
            relationId: {
                required: true,
            },
            logId: {
                required: true,
            },
            trajectoryId: {
                required: true,
            },
            milestoneProgressId: {
                required: true,
            },
            actionProgressId: {
                required: true,
            }
        },
        components: {
            'log-form-coach': LogFormCoach,
        },
        computed: {
            overrideEndpoint() {
                return route('logs.index');
            }
        }
    }
</script>

<style lang="css" scoped>
</style>
